import React, { useState } from "react";
import PropTypes from "prop-types";
import { useIntl, FormattedMessage } from "react-intl";
import { Form, Row, Col, Button } from "react-bootstrap";

import { formatDate } from "../../../../utils/date-utils/date-utils";
import { CustomModal } from "../../../common/modal/custom-modal";
import { CustomerSelector } from "./customer-selector";

export const OnSiteServiceWorksheetDetail = ({
  sw,
  handleClose,
  handleConfirm,
}) => {
  const intl = useIntl();

  const [signEmail, setSignEmail] = useState(
    sw.data.signature.email ? sw.data.signature.email : "",
  );
  const [customer, setCustomer] = useState(null);
  const [missingCustomer, setMissingCustomer] = useState(false);

  const DataRow = ({ label, value, action }) => (
    <Row>
      <Col sm="6" md="4" lg="3">
        {label ? `${label}:` : null}
      </Col>
      <Col sm="6" md="8" lg="9">
        {action ? (
          <Button variant="link" onClick={action} className="p-0">
            {value}
          </Button>
        ) : (
          <b>{value}</b>
        )}
      </Col>
    </Row>
  );

  const getButtons = () => {
    const buttons = [];
    buttons.push({
      variant: "primary",
      text: intl.formatMessage({
        id: "page.onsiteserviceworksheets.button.confirm",
      }),
      action: () => {
        if (!customer) {
          setMissingCustomer(true);
        } else {
          handleConfirm(signEmail ? signEmail : null, customer);
        }
      },
    });
    return buttons;
  };

  return (
    <CustomModal
      title={sw.data.customer.name}
      handleClose={handleClose}
      buttons={getButtons()}
    >
      <>
        <DataRow
          label={intl.formatMessage({
            id: "data.onsiteserviceworksheet.data.customer",
          })}
          value={sw.data.customer.name}
        />
        <Row>
          <Col sm="6" md="4" lg="3"></Col>
          <Col sm="6" md="8" lg="9">
            <div className="mb-2">
              <CustomerSelector
                error={missingCustomer}
                selected={customer}
                handleChange={(customer) => {
                  setCustomer(customer);
                  setMissingCustomer(customer ? false : true);
                }}
              />
            </div>
          </Col>
        </Row>
        <DataRow
          label={intl.formatMessage({
            id: "data.onsiteserviceworksheet.data.createdTime",
          })}
          value={sw.data.createdTime}
        />
        <DataRow
          label={intl.formatMessage({
            id: "data.onsiteserviceworksheet.data.user",
          })}
          value={`${sw.data.user.name} (${sw.data.user.email})`}
        />
        <DataRow
          label={intl.formatMessage({
            id: "data.onsiteserviceworksheet.data.time",
          })}
          value={`${formatDate(new Date(sw.data.data.start))} - ${formatDate(new Date(+sw.data.data.end))}`}
        />
        <DataRow
          label={intl.formatMessage({
            id: "data.onsiteserviceworksheet.data.signature.label",
          })}
          value={null}
        />
        <Row>
          <Col sm="6" md="4" lg="3"></Col>
          <Col sm="6" md="8" lg="9">
            <Form.Control
              className="mb-2"
              type="text"
              placeholder={intl.formatMessage({
                id: "data.onsiteserviceworksheet.data.signature.name",
              })}
              value={sw.data.signature.name ? sw.data.signature.name : ""}
              disabled
            />
          </Col>
        </Row>
        <Row>
          <Col sm="6" md="4" lg="3"></Col>
          <Col sm="6" md="8" lg="9">
            <Form.Control
              className="mb-2"
              type="text"
              placeholder={intl.formatMessage({
                id: "data.onsiteserviceworksheet.data.signature.tel",
              })}
              value={sw.data.signature.tel ? sw.data.signature.tel : ""}
              disabled
            />
          </Col>
        </Row>
        <Row>
          <Col sm="6" md="4" lg="3"></Col>
          <Col sm="6" md="8" lg="9">
            <Form.Control
              className="mb-2"
              type="text"
              placeholder={intl.formatMessage({
                id: "data.onsiteserviceworksheet.data.signature.email",
              })}
              value={signEmail}
              onChange={(event) => {
                setSignEmail(event.target.value);
              }}
            />
          </Col>
        </Row>
        <DataRow
          label={intl.formatMessage({
            id: "data.onsiteserviceworksheet.data.status.label",
          })}
          value={intl.formatMessage({
            id: `data.onsiteserviceworksheet.data.status.value.${sw.data.status}`,
          })}
        />
        <hr />
        <DataRow
          label={intl.formatMessage({
            id: "data.onsiteserviceworksheet.data.updateTime",
          })}
          value={sw.data.modifyTime}
        />
        <DataRow
          label={intl.formatMessage({
            id: "data.onsiteserviceworksheet.data.updateUser",
          })}
          value={`${
            sw.data.modifyUser
              ? `${sw.data.modifyUser.name} (${sw.data.modifyUser.email})`
              : "-"
          }`}
        />
        <hr />
        <h5>
          <FormattedMessage id="data.onsiteserviceworksheet.data.template.name" />
        </h5>
        <div className="ps-4">
          <div>
            <DataRow
              label={intl.formatMessage({
                id: "data.onsiteserviceworksheet.data.machineNumber",
              })}
              value={sw.data.data.templates["0"].machineService.machineNumber}
            />
            <DataRow
              label={intl.formatMessage({
                id: "data.onsiteserviceworksheet.data.machineType",
              })}
              value={sw.data.data.templates["0"].machineService.machineType}
            />
            <DataRow
              label={intl.formatMessage({
                id: "data.onsiteserviceworksheet.data.machineOperatingHours",
              })}
              value={
                sw.data.data.templates["0"].machineService.machineOperatingHours
              }
            />
          </div>
          <div className="mt-2">
            <DataRow
              label={intl.formatMessage({
                id: "data.onsiteserviceworksheet.data.outing",
              })}
              value={sw.data.data.workData.outing}
            />
            <DataRow
              label={intl.formatMessage({
                id: "data.onsiteserviceworksheet.data.workTime",
              })}
              value={sw.data.data.workData.workTime}
            />
            <DataRow
              label={intl.formatMessage({
                id: "data.onsiteserviceworksheet.data.workType.label",
              })}
              value={intl.formatMessage({
                id: `data.onsiteserviceworksheet.data.workType.value.${sw.data.data.workData.workType}`,
              })}
            />
          </div>
          <div className="mt-2">
            <DataRow
              label={intl.formatMessage({
                id: "data.onsiteserviceworksheet.data.note",
              })}
              value={sw.data.data.workData.note}
            />
          </div>
          {sw.data.data.templates["0"].fields.map((field, index) => (
            <div key={index} className="mt-2">
              <b>
                {index + 1}. {sw.data.data.templates["0"].fields[index].name}
              </b>
              {sw.data.data.templates["0"].fields[index].text ? (
                <div>{sw.data.data.templates["0"].steps[index].text}</div>
              ) : null}
              {sw.data.data.templates["0"].fields[index].photos ? (
                <div>
                  <FormattedMessage
                    id="data.onsiteserviceworksheet.data.attachedFile"
                    values={{
                      count:
                        sw.data.data.templates["0"].steps[index].photos.length,
                    }}
                  />
                </div>
              ) : null}
            </div>
          ))}
        </div>
      </>
    </CustomModal>
  );
};

OnSiteServiceWorksheetDetail.propTypes = {
  sw: PropTypes.object.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleConfirm: PropTypes.func.isRequired,
};
